import React from 'react'

export default class Loader extends React.Component{
	render(){
		return(
			<div className="main-container">
				<div className="secondary-container">
				<div className="lipstick-container">
					<hr className="lipstick"/>
						<hr className="lipstick-hr"/>
						<hr className="lipstick-base"/>
					<p className="get-mes">Getting your shades ready...</p>
				</div>
				</div>
			</div>
		)
	}
}